export default "__VITE_ASSET__Bv4g6XQA__"